import findIndex from 'lodash/findIndex';

const compareModule = {
  namespaced: true,
  state: {
    racks: {},
    compareRackDialogVisible: false,
  },

  mutations: {
    setRacks(state, racks) {
      state.racks = racks;
    },
    setCompareRackDialog(state, payload) {
      state.compareRackDialogVisible = payload;
    },
  },

  actions: {
    addToRack({commit, rootState, state}, {item, toast, toastMsg}) {
      const unitId = rootState.backend.unitId;
      if (!state.racks[unitId]) {
        state.racks[unitId] = [];
      }
      state.racks[unitId].push(item);
      commit('setRacks', state.racks);

      toast({
        type: 'success',
        message: toastMsg,
      });
    },

    createRack({commit, rootState, state}) {
      const unitId = rootState.backend.unitId;
      if (!state.racks[unitId]) {
        state.racks[unitId] = [];
        commit('setRacks', state.racks);
      }
    },

    removeFromRack({commit, rootState, state}, {item, toast, toastMsg}) {
      const unitId = rootState.backend.unitId;
      const itemIndex = findIndex(state.racks[unitId], {productCode: item.productCode});
      if (itemIndex > -1) {
        state.racks[unitId].splice(itemIndex, 1);
      }
      commit('setRacks', state.racks);
      toast({
        type: 'success',
        message: toastMsg,
      });
    },

    emptyRack({commit, rootState, state}, {toast, toastMsg}) {
      const unitId = rootState.backend.unitId;
      state.racks[unitId] = [];
      commit('setRacks', state.racks);
      toast({
        type: 'success',
        message: toastMsg,
      });
    },
  },

  getters: {
    currentRack(state, getters, rootState) {
      return state.racks[rootState.backend.unitId];
    },
  },
};

export default compareModule;
